import React, { useState, useEffect }  from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Services.css'

const originalServices = [
  {
    id: 1,
    title: "Full Stack Website Development",
    imageUrl: "https://i.pinimg.com/564x/40/76/7d/40767df5a3a8899fca21f1f0c59e112f.jpg",
    description: `Transforming your vision into a dynamic, user-friendly website, our Full Stack Development offers an end-to-end solution. From front-end artistry to powerful back-end functionalities, get ready for a seamless, scalable digital experience in just 3-4 weeks.`,
  },
  {
    id: 2,
    title: "Static Website Design",
    imageUrl: "https://i.pinimg.com/564x/69/13/f5/6913f5171014c7147612d6eadf29bc68.jpg",
    description: `Crafting your digital identity with creative flair, our Static Website Design service blends aesthetics with efficiency. Perfect for portfolios and businesses, we promise a standout online presence delivered with precision in 2-3 weeks.`,
  },
  {
    id: 3,
    title: "Online CV Creation",
    imageUrl: "https://i.pinimg.com/564x/63/dc/84/63dc8433e79b714f154c38ba3a1c1470.jpg",
    description: `Elevate your professional story with our Online CV Creation. Combining modern designs with digital proficiency, we highlight your skills in an engaging format, ready to captivate employers in just 24 hours.`,
  },
  {
    id: 4,
    title: "Portfolio Development",
    imageUrl: "https://i.pinimg.com/564x/f2/2d/2a/f22d2afa19665d3dcf1d1480f1f527c2.jpg",
    description: `Showcase your talent and achievements with our bespoke Portfolio Development. We create visually stunning and personalized portfolios that reflect your unique journey, all crafted and ready in just 48 hours.`,
  },
];

const Service = () => {
  const [services, setServices] = useState(originalServices);
  const email = "brianmwithi@gmail.com";
  const phoneNumber = "+254 740 297050";

  const createMailtoLink = (title) => `mailto:${email}?subject=${encodeURIComponent(title)}`;
  const createWhatsAppLink = (title) => `https://wa.me/${phoneNumber}?text=${encodeURIComponent(`Hello, I'm interested in your service: ${title}`)}`;

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        const selectedServiceIndex = originalServices.findIndex(service => service.id.toString() === hash);
        if (selectedServiceIndex > -1) {
          const newServices = [...originalServices];
          const [selectedService] = newServices.splice(selectedServiceIndex, 1);
          newServices.unshift(selectedService);
          setServices(newServices);
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange, false);
    handleHashChange(); // also call it once to check initial hash

    return () => {
      window.removeEventListener('hashchange', handleHashChange, false);
    };
  }, []);

  return (
    <Container className="services-section">
      <h2 className="services-title">Services</h2>
      <Row className="justify-content-center">
        {services.map((service) => (
          <Col xs={12} sm={6} key={service.id} className="mb-4">
            <div className="services-card" id={service.id}>
              {service.imageUrl && <img src={service.imageUrl} alt={service.title} />}
              <h3 className="services-title">{service.title}</h3>
              <p className="services-description">{service.description}</p>
              <Button href={createMailtoLink(service.title)} className="contact-button">Contact Us</Button>
              <Button href={createWhatsAppLink(service.title)} className="whatsapp-button" target="_blank">WhatsApp</Button>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Service;